import { makeStyles } from "@material-ui/core"

import { isSmallScreen } from "@/utils/checkDevice"

import { colors } from "@/styles/colors"

import { CHAT_LEFT_SIDE_WIDTH } from "@/pages/Attendance/Chat/ChatListPanel/styles"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	pageContainer: {
		height: "100%"
	},
	chatContainer: {
		height: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.04)"
	},
	drawerPaper: {
		width: isSmallScreen ? "100%" : CHAT_LEFT_SIDE_WIDTH,
		borderRight: `1px solid ${colors.gray[100]}`,
		borderLeft: `1px solid ${colors.gray[100]}`,
		overflow: "hidden"
	},
	input: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "3px",
		"&::before": {
			borderBottom: "none"
		}
	}
})

export default useStyles
